import React from 'react'

import { Provider } from 'react-redux'
import store from 'redux/store'

import {
  BrowserRouter as Router,
  Switch,
  Route
} from 'react-router-dom'

import { ToastContainer } from 'react-toastify'

import Messages from '@views/messages/messages.component'
import NotFound from '@components/not-found-container/not-found-container.component'
import Tips from '@views/tips/tips.component'
import ErrorModal from '@components/error-modal/error-modal.component'

import useStyles from './App.styles'

import './services/firebase'

const App = () => {
  useStyles()
  return (
    <Provider store={store}>
      <Router basename={process.env.PUBLIC_URL}>
        <Switch>
          <Route path='/messages'>
            <Messages />
          </Route>
          <Route path='/tips'>
            <Tips />
          </Route>
          <Route path='/404'>
            <NotFound />
          </Route>
        </Switch>
      </Router>
      <ToastContainer />
      <ErrorModal />
    </Provider>
  )
}

export default App
